import {Link, useSearchParams} from "react-router-dom";

import AuthenticationLayout from "../layouts/AuthenticationLayout";
import useTranslation from "../hooks/translations";
import {Button, Form} from "react-bootstrap";
import {useMemo, useRef, useState} from "react";
import InputField from "../components/InputField";
import {useApi} from "../contexts/ApiProvider";
import UserService from "../services/UserService";
import {toast} from "react-toastify";

export default function ResetPasswordPage() {
  const translations = useTranslation();
  const api = useApi()
  const userService = useMemo(() => new UserService(api), [api]);

  const newPasswordField = useRef();
  const confirmPasswordField = useRef();
  const [formErrors, setFormErrors] = useState({});

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const onSubmit = async (event) => {
    event.preventDefault();

    const newPassword = newPasswordField.current.value;
    const confirmPassword = confirmPasswordField.current.value;

    const errors = {};
    if (!newPassword) {
      errors.newPassword = translations.errorNewPassword;
    }

    if (!confirmPassword) {
      errors.confirmPassword = translations.errorConfirmPassword;
    }

    if (newPassword !== confirmPassword) {
      errors.confirmPassword = translations.errorConfirmMismatchPassword;
    }

    setFormErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }

    if (!token) {
      toast.error(translations.resetPasswordLinkError);
      return;
    }

    const result = await userService.resetPassword({
      new_password: newPassword,
      token: token
    })

    if (result.ok) {
      newPasswordField.current.value = "";
      confirmPasswordField.current.value = "";
      toast.success(translations.passwordUpdateSuccess)
    }
  };

  return (
    <AuthenticationLayout>
      <div className="col-lg-5">
        <div className="card shadow-lg border-0 rounded-lg mt-5">
          <div className="card-header justify-content-center">
            <h3 className="fw-light my-4">{translations.passwordRecovery}</h3>
          </div>
          <div className="card-body">
            <Form onSubmit={onSubmit}>
              <div className="mb-3">
                <InputField
                  type="password"
                  name="newPassword"
                  label={translations.newPassword}
                  placeholder={translations.enterNewPassword}
                  error={formErrors.newPassword}
                  fieldRef={newPasswordField}
                />
              </div>
              <div className="mb-3">
                <InputField
                  type="password"
                  name="confirmPassword"
                  label={translations.confirmPassword}
                  placeholder={translations.enterConfirmPassword}
                  error={formErrors.confirmPassword}
                  fieldRef={confirmPasswordField}
                />
              </div>
              <div
                className="d-flex align-items-center justify-content-between mt-4 mb-0">
                <Link className="small"
                      to="/login">{translations.returnToLogin}</Link>
                <Button className="btn btn-primary"
                        type="submit">{translations.resetPassword}</Button>
              </div>
            </Form>
          </div>
          {/*<div className="card-footer text-center">*/}
          {/*  <div className="small">*/}
          {/*    <Link to="/register">Need an account? Sign up!</Link>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
      </div>
    </AuthenticationLayout>
  );
}
